import DOMPurify from "dompurify";

// Config permite el HTML que produce TipTap (RichEditor) y bloquea todo lo peligroso.
const CONFIG = {
  ALLOWED_TAGS: [
    "p", "br", "b", "strong", "i", "em", "u", "s", "mark",
    "h1", "h2", "h3", "h4", "h5", "h6",
    "ul", "ol", "li",
    "a", "blockquote", "code", "pre", "hr",
    "span", "div",
  ],
  ALLOWED_ATTR: ["href", "target", "rel", "class", "style"],
  ALLOW_DATA_ATTR: false,
};

// Fuerza rel="noopener noreferrer" y target="_blank" en enlaces externos
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A") {
    const href = node.getAttribute("href") || "";
    if (/^https?:/i.test(href)) {
      node.setAttribute("target", "_blank");
      node.setAttribute("rel", "noopener noreferrer");
    }
  }
});

export default function HtmlOrText({ html, className = "prose-body" }) {
  if (!html) return null;
  const isHtml = /<[a-z][\s\S]*>/i.test(html);
  if (!isHtml) {
    return <p className={className}>{html}</p>;
  }
  const clean = DOMPurify.sanitize(html, CONFIG);
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
